import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'
import { style } from './paper.style.js'
import { classMap } from 'lit/directives/class-map.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { getAssignedNodes, } from '@cloudsuite/mosaic-shared/testing/get-elements.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'


export const paperVariants = ['primary', 'secondary', 'error', 'info', 'success', 'warning'] as const
export type paperVariantTypes = typeof paperVariants

export const paperSizes = ['default', 'small', 'large', 'extraLarge'] as const
export type paperSizeTypes = typeof paperSizes

@customElement('cse-paper')
export class CSEPaper extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, fontStyles, style]

  @property({ type: String })
  variant: paperVariantTypes[number] = 'secondary'

  @property({ type: Boolean })
  bordered = false

  @property({ type: String })
  size: paperSizeTypes[number] = 'default'

  @state()
  headingSlotIsFilled = false

  @query('slot[name="heading"]')
  headingSlot!: HTMLSlotElement

  protected override firstUpdated() {
    this.hasSlotContent()  
  }

  hasSlotContent() {
    this.headingSlotIsFilled = getAssignedNodes(this.headingSlot).length > 0
  }

  override render() {
    return html`
      <div class="${classMap({
        'cse-paper': true,
        [`variant-${this.variant}`]: true,
        'bordered': this.bordered,
        'size-small': this.size === 'small',
        'size-large': this.size === 'large',
        'size-extra-large': this.size === 'extraLarge',
      })}">
        <slot
          @slotchange=${this.hasSlotContent}
          name="heading"
          class="${classMap({
            'heading': true,
            'hidden': !this.headingSlotIsFilled,
            'font-heading-3': true,
          })}"
        ></slot>
        <slot class="font-body"></slot>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-paper': CSEPaper
  }
}
